import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Header from 'layouts/header/Header';
import SideBar from 'layouts/sidebar/Sidebar';

const Default = () => (
  <>
    <Header />
    <main className={'main'}>
      <div id={'content-wrap'}>
        <SideBar>
          <Suspense>
            <Outlet />
          </Suspense>
        </SideBar>
      </div>
    </main>
  </>
);

export default Default;
